import SlotSelectorModal from "../../../Components/User/Dashboard/SlotSelectorModal/SlotSelectorModal";
import DoorSelectorModal from "../../../Components/User/Dashboard/DoorSelectorModal/DoorSelectorModal";
import WifiAmenityModal from "../../../Components/User/Dashboard/WifiAmenityModal/WifiAmenityModal";
import {
  getAmenitiesList,
  openDoor,
} from "../../../Redux/Bookings/BookingsActions";
import SelectCard from "../../../Components/User/Bookings/SelectCard/SelectCard";
import { retrySubscriptionPayment } from "../../../Redux/Members/MembersActions";
import { getDashboardData } from "../../../Redux/Dashboard/DashboardActions";
import Accordion from "../../../Components/Common/Accordion/Accordion";
import { getProfile } from "../../../Redux/Profile/ProfileActions";
import Loading from "../../../Components/Common/Loading/Loading";
import { AppDispatch, RootState } from "../../../Redux/store";
import Modal from "../../../Components/Common/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import toastHelper from "../../../Util/toastHelper";
import React, { useEffect, useState } from "react";
import WifiImage from "../../../Assets/Wifi.gif";
import LockImage from "../../../Assets/Lock.gif";
import { Link, useNavigate } from "react-router";
import styles from "./Dashboard.module.scss";
import { RiAlertLine } from "react-icons/ri";
import { FaUnlockAlt } from "react-icons/fa";
import { CiClock1 } from "react-icons/ci";
import moment from "moment";

interface Amenity {
  amenityId: number;
  name: string;
  image: string;
  isActive: boolean;
  lastVisited: string | null;
  amenityTypeName: string;
  isBookableSlot: boolean;
  maxhours: number;
  doors: AmenityDoor[];
  amenitySlots: AmenitySlot[];
}

interface AmenityDoor {
  id: number;
  doorName: string;
  doorId: number;
  panelId: number;
  amenityId: number;
}

interface AmenitySlot {
  amenityId: number;
  endDate: string;
  id: number;
  memberId: number;
  startDate: string;
}
function Dashboard() {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const [isWifiModalActive, setIsWifiModalActive] = useState(false);
  const [isDoorSelectorModalActive, setIsDoorSelectorModalActive] =
    useState(false);
  const [isSlotSelectorModalActive, setSlotSelectorModalActive] =
    useState(false);
  const [isSelectCardModalActive, setIsSelectCardModalActive] = useState(false);
  const [selectedCard, setSelectedCard] = useState<string>("");
  const [selectedAmenity, setSelectedAmenity] = useState<Amenity | null>(null);
  const { data, loading } = useSelector((state: RootState) => state.dashboard);
  const { amenitiesList } = useSelector((state: RootState) => state.bookings);
  const { openDoorLoading, addMemberAmenitySlotLoading } = useSelector(
    (state: RootState) => state.bookings,
  );
  const { retrySubscriptionPaymentLoading } = useSelector(
    (state: RootState) => state.members,
  );

  useEffect(() => {
    dispatch(getDashboardData({ navigate: navigate }));
    dispatch(getProfile({ navigate: navigate }));
    dispatch(getAmenitiesList());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const openDoorHandler = (amenity: Amenity) => {
    if (!amenity?.isBookableSlot && amenity?.doors?.length === 1) {
      dispatch(
        openDoor({
          amenityId: amenity.amenityId.toString(),
          doorId: amenity.doors[0].id.toString(),
        }),
      );

      return;
    }

    if (!amenity?.isBookableSlot && amenity?.doors?.length > 1) {
      setSelectedAmenity(amenity);
      setIsDoorSelectorModalActive(true);
      return;
    }

    if (amenity?.isBookableSlot) {
      if (amenity?.amenitySlots?.length > 0) {
        const base = moment().startOf("day");
        const nowTime = base
          .clone()
          .add(moment().hours(), "hours")
          .add(moment().minutes(), "minutes");

        for (const slot of amenity?.amenitySlots) {
          const start = moment(slot.startDate);
          const end = moment(slot.endDate);

          const startTime = base
            .clone()
            .add(start.hours(), "hours")
            .add(start.minutes(), "minutes");
          const endTime = base
            .clone()
            .add(end.hours(), "hours")
            .add(end.minutes(), "minutes");

          if (
            nowTime.isSameOrAfter(startTime) &&
            nowTime.isSameOrBefore(endTime)
          ) {
            if (amenity?.doors?.length === 1) {
              dispatch(
                openDoor({
                  amenityId: amenity.amenityId.toString(),
                  doorId: amenity.doors[0].id.toString(),
                }),
              );
              return;
            }
            setSelectedAmenity(amenity);
            setIsDoorSelectorModalActive(true);
            return;
          }
        }

        toastHelper.error(
          "Its not your booking time currently, please try again during your booked slot time",
        );
        return;
      } else {
        toastHelper.error("No slots available, please add firs");
      }
    }
  };

  const retrySubscriptionPaymentHandler = () => {
    if (selectedCard) {
      if (!retrySubscriptionPaymentLoading) {
        const successHandler = () => {
          setIsSelectCardModalActive(false);
          setSelectedCard("");
          dispatch(getDashboardData({ navigate: navigate }));
        };

        dispatch(
          retrySubscriptionPayment({
            cardId: selectedCard,
            navigate: navigate,
            successHandler: successHandler,
          }),
        );
      }
    } else {
      toastHelper.error("Please select a card");
    }
  };

  const wifiHandler = () => {
    setIsWifiModalActive(true);
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <React.Fragment>
      {(retrySubscriptionPaymentLoading || addMemberAmenitySlotLoading) && (
        <Loading />
      )}
      <Modal
        isOpen={isSelectCardModalActive}
        setIsOpen={setIsSelectCardModalActive}
      >
        <SelectCard
          selectedCard={selectedCard}
          setSelectedCard={setSelectedCard}
          label="Retry Payment"
        />
        <div className={styles.proceedButtonContainer}>
          <button
            onClick={retrySubscriptionPaymentHandler}
            className={styles.button}
          >
            Proceed
          </button>
          <button
            onClick={() => setIsSelectCardModalActive(false)}
            className={styles.cancelButton}
          >
            Cancel
          </button>
        </div>
      </Modal>
      <WifiAmenityModal
        isOpen={isWifiModalActive}
        setIsOpen={setIsWifiModalActive}
      />
      <DoorSelectorModal
        amenity={selectedAmenity as Amenity}
        isOpen={isDoorSelectorModalActive}
        setIsOpen={setIsDoorSelectorModalActive}
      />
      <SlotSelectorModal
        amenity={selectedAmenity as Amenity}
        isOpen={isSlotSelectorModalActive}
        setIsOpen={setSlotSelectorModalActive}
      />
      <div className={styles.mainContainer}>
        {openDoorLoading && <Loading />}
        <div className={styles.bodyContainer}>
          <div className={styles.headingContainer}>
            <h1>Welcome {data?.member?.fullName}</h1>
          </div>
          {moment().isAfter(moment(data?.lease?.endDate)) &&
            !data?.lease?.isActive &&
            data?.lease?.onHold && (
              <div className={styles.alertMessageContainer}>
                <div className={styles.alertMessage}>
                  <div className={styles.alertIcon}>
                    <RiAlertLine />
                  </div>
                  <div className={styles.alertMessageText}>
                    <span className={styles.alertBold}>Alert!</span>
                    <p>Your lease has been expired, kindly contact support</p>
                  </div>
                </div>
              </div>
            )}
          <div className={styles.locationContainerWrapper}>
            <div className={styles.locationLeftSide}>
              <div className={styles.locationContainer}>
                <div className={styles.imageContainer}>
                  <img
                    width={100}
                    height={100}
                    className={styles.image}
                    src="https://images.unsplash.com/photo-1534237710431-e2fc698436d0?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8YnVpbGRpbmd8ZW58MHx8MHx8fDA%3D"
                    alt=""
                  />
                </div>
                <div className={styles.locationInfo}>
                  <p className={styles.name}>{data?.building?.name}</p>
                  <p className={styles.address}>
                    {data?.building?.address}, {data?.building?.city},{" "}
                    {data?.building?.state}, {data?.building?.zip}
                  </p>
                </div>
              </div>
              <div className={styles.amenitiesContainer}>
                <div className={styles.headingContainer}>
                  <p>My Amenities</p>
                </div>
                <div className={styles.amenitiesList}>
                  {data?.package?.packageAmenities?.map(
                    (amenity: any, i: number) => {
                      if (amenity?.amenityTypeName === "Wifi") {
                        return (
                          <div
                            className={styles.amenity}
                            key={i}
                            onClick={() => wifiHandler()}
                          >
                            <div className={styles.lockImageContainer}>
                              <img
                                className={styles.lockImage}
                                src={WifiImage}
                                alt="Wifi"
                              />
                            </div>
                            <div className={styles.imageContainer}>
                              <img
                                className={styles.image}
                                width={100}
                                height={100}
                                src={amenity?.image}
                                alt=""
                              />
                            </div>
                            <div className={styles.infoMainContainer}>
                              <div className={styles.infoContainer}>
                                <p className={styles.name}>{amenity?.name}</p>
                                <p className={styles.lastVisited}>
                                  Last Visit{" "}
                                  {amenity?.lastVisited
                                    ? moment(amenity?.lastVisited).format(
                                        "MM/DD/YYYY",
                                      )
                                    : "N/A"}
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      }
                      return (
                        <div
                          className={styles.amenity}
                          key={i}
                          onClick={() => openDoorHandler(amenity)}
                        >
                          <div className={styles.lockImageContainer}>
                            <img
                              className={styles.lockImage}
                              src={LockImage}
                              alt="Lock"
                            />
                          </div>
                          {amenity?.isBookableSlot && (
                            <div className={styles.addSlotButtonContainer}>
                              <button
                                className={styles.addSlotButton}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedAmenity(amenity);
                                  setSlotSelectorModalActive(true);
                                }}
                              >
                                Add Slot
                              </button>
                            </div>
                          )}
                          <div className={styles.imageContainer}>
                            <img
                              className={styles.image}
                              width={100}
                              height={100}
                              src={amenity?.image}
                              alt=""
                            />
                          </div>
                          <div className={styles.infoMainContainer}>
                            <div className={styles.infoContainer}>
                              <p className={styles.name}>{amenity?.name}</p>
                              <p className={styles.lastVisited}>
                                Last Visit{" "}
                                {amenity?.lastVisited
                                  ? moment(amenity?.lastVisited).format(
                                      "MM/DD/YYYY",
                                    )
                                  : "N/A"}
                              </p>
                            </div>
                            <div className={styles.openDoorContainer}>
                              <FaUnlockAlt className={styles.icon} />
                            </div>
                          </div>
                        </div>
                      );
                    },
                  )}
                </div>
              </div>
            </div>
            <div className={styles.summaryContainer}>
              <div className={styles.packageContainer}>
                <div className={styles.info}>
                  <p className={styles.package}>Package</p>
                  <p className={styles.economy}>{data?.package?.packageName}</p>
                  <p className={styles.renew}>
                    Last Renew on{" "}
                    {moment(data?.package?.renewalDate).format("MM/DD/YYYY")}
                  </p>
                </div>
                <div className={styles.buttonContainers}>
                  <Link className={styles.button} to="/upgrade">
                    Upgrade
                  </Link>
                  {data?.member?.registered === false &&
                    data?.member?.subscriptionFailed === true && (
                      <button
                        className={styles.button}
                        onClick={() => setIsSelectCardModalActive(true)}
                      >
                        Retry Payment
                      </button>
                    )}
                </div>
              </div>
              <div className={styles.accordionContainer}>
                <Accordion
                  title="My Bookings"
                  color="#d40d0d"
                  isEmpty={
                    Array.isArray(data?.bookings) &&
                    data?.bookings?.length === 0
                  }
                  headerChildren={
                    <Link
                      to="/bookings/create"
                      className={styles.headerButtonContainer}
                    >
                      <button className={styles.headerButton}>
                        CREATE BOOKING
                      </button>
                    </Link>
                  }
                >
                  <div className={styles.bookingsList}>
                    {data?.bookings?.map((booking: any, i: number) => {
                      return (
                        <div className={styles.booking} key={i}>
                          <div className={styles.dateContainer}>
                            <CiClock1 size={20} />
                            <div className={styles.date}>
                              <p>
                                {moment(booking?.startTime).format(
                                  "MM/DD/YYYY",
                                )}{" "}
                                <span>
                                  {moment(booking?.startTime).format("hh:mm A")}{" "}
                                  - {moment(booking?.endTime).format("hh:mm A")}
                                </span>
                              </p>
                            </div>
                          </div>
                          <div className={styles.infoContainer}>
                            <p>{booking?.amenityName}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Accordion>
              </div>

              <div className={styles.accordionContainer}>
                <Accordion
                  title="Available Amenities"
                  color="#d40d0d"
                  isEmpty={
                    Array.isArray(amenitiesList) && amenitiesList?.length === 0
                  }
                >
                  {amenitiesList?.map((amenity: any, i: number) => {
                    return (
                      <div key={i} className={styles.accordionBodyContainer}>
                        <p className={styles.rateType}>
                          {amenity?.rateTypeName}
                        </p>
                        <h3 className={styles.name}>{amenity?.name}</h3>
                      </div>
                    );
                  })}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Dashboard;
